export default __webpack_public_path__ + "images/return-removals-icon.png";